import { render, screen } from "@testing-library/react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Link } from "react-router-dom";

import Header from "../component/header";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import IndFlag from "../img/flag-india.png";

import trophy from "../img/trophy.png";

import RightBanner from "../img/right-banner.png";
import RightBanner1 from "../img/right-banner-1.png";
import Dice from "../img/dise.png";
import C1 from "../img/c-01.png";
import C2 from "../img/c-2.png";
import C3 from "../img/c-3.png";
import C4 from "../img/item1.png";
import C5 from "../img/item2.png";
import C6 from "../img/item3.png";
import C7 from "../img/item4.png";
import C8 from "../img/item5.png";
import C9 from "../img/item6.png";
import Banner from "../img/casino-banner.png";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { useEffect } from "react";
import { isEmpty, startCase } from "lodash";
import { useState } from "react";
import {
  AviatorGames,
  BetGames,
  DepositWithrawDataArray,
  EvolutionNew,
  EzugiNew,
  gamesLiveArray,
  PokerGames,
  RoyalGamming,
  RoyalGammingNew,
  Vivo,
} from "../Utils/constants";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import SubCasino from "../component/SubCasino";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
function CasinoPage() {
  const params = useParams();
  let { user, launchCasino, dolaunchCasinoNew, setLoginModal } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const [key, setKey] = useState("poker");
  useEffect(() => {
    document.getElementById("loading").style.display = "flex";
    if (!isEmpty(params?.type)) {
      if (params?.type == "Indian_Poker") {
        setKey("poker");
      } else if (params?.type == "RoyalGamming") {
        setKey("royal");
      } else {
        setKey(params?.type);
        if (!isEmpty(obj[params?.type])) {
          setSubCasino(obj[params?.type][0]);
        }
      }
    } else {
      setKey("poker");
    }
  }, [params]);

  useEffect(() => {
    let timer = setTimeout(() => {
      document.getElementById("loading").style.display = "none";
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [params]);
  const [subCasino, setSubCasino] = useState("");
  const [array, setArray] = useState([]);
  useEffect(() => {
    setArray({
      live:
        gamesLiveArray?.filter((res) => {
          return ["ROULETTE", "GAME-SHOWS"].includes(res?.type);
        }) || [],
      evolition:
        gamesLiveArray?.filter((res) => {
          return res?.platForm == "EVOLUTION";
        }) || [],
      awc:
        gamesLiveArray?.filter((res) => {
          return res?.type == "AWC";
        }) || [],
      sexy:
        gamesLiveArray?.filter((res) => {
          return res?.platForm == "SEXYBCRT";
        }) || [],
      dice:
        gamesLiveArray?.filter((res) => {
          return res?.type == "DICE";
        }) || [],
      table:
        gamesLiveArray?.filter((res) => {
          return res?.type == "TABLE";
        }) || [],
      slot:
        gamesLiveArray?.filter((res) => {
          return res?.type == "SLOT";
        }) || [],
      fishing:
        gamesLiveArray?.filter((res) => {
          return res?.type == "FISHING";
        }) || [],
      egame:
        gamesLiveArray?.filter((res) => {
          return res?.type == "EGAME";
        }) || [],
    });
  }, []);

  const handel = (res) => {
    if (!isEmpty(user)) {
      launchCasino({
        platForm: res?.platForm,
        gameType: res?.gameType,
        casinoType: res?.casinoType,
        isLobbyTrue: res?.isLobbyTrue,
      });
    } else {
      setLoginModal(true);
    }
  };
  const handelChange = (res, game, type) => {
    if (!isEmpty(user)) {
      dolaunchCasinoNew(
        game == "poker"
          ? {
              gameCode: res?.gameCode,
              legacy: res?.legacy,
              type: type,
            }
          : {
              gameCode: res?.gameCode,
              legacy: res?.legacy,
              type: type,
            },
      );
    } else {
      setLoginModal(true);
    }
  };
  const ImageWithFallback = ({ src, fallbackSrc, alt, ...props }) => {
    const [imageSrc, setImageSrc] = useState(src);

    const handleError = () => {
      setImageSrc(fallbackSrc);
    };

    return (
      <LazyLoadImage
        src={imageSrc}
        alt={alt}
        onError={handleError}
        effect="blur" // Optional effect
        {...props}
      />
    );
  };

  function mergeGameData(arr1, arr2) {
    return arr1.map((item1) => {
      const match = arr2.find(
        (item2) => item2?.Name?.toLowerCase() === item1?.name?.toLowerCase(),
      );

      return match
        ? {
            ...item1,
            platFormCode: match.platFormCode,
            gameType: match.gameType,
            casinoType: match.casinoType,
          }
        : item1; // no match, return original item
    });
  }
  console.log(
    mergeGameData(EvolutionNew, dummy).map(({ game_id, ...rest }) => rest),
  );
  return (
    <Layout>
      <Col md={12}>
        {/* <div data-aos="zoom-in-up" className="mb-2">
          <img src={Banner} style={{ maxWidth: "100%",height:"200px",objectFit:"contain" }} />
        </div> */}

        <div data-aos="zoom-in-up" className="casinoTabs mb-3">
          <Tabs
            activeKey={key}
            onSelect={(e) => {
              setKey(e);
              if (!isEmpty(obj[e])) {
                setSubCasino(obj[e][0]);
              }
            }}
            id="uncontrolled-tab-example"
            className="mb-2"
          >
            <Tab eventKey="poker" title="Indian Poker">
              <Row>
                {PokerGames?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.image} />
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handelChange(res, "poker", "first")}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Casino" title="Casino">
              <Row>
                {DepositWithrawDataArray?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <ImageWithFallback
                          src={res?.image || res?.url_thumb}
                          fallbackSrc={
                            "https://cdn.dreamdelhi.com/gap-logo.webp"
                          }
                        />
                        <h2>
                          <a href="#">{res?.title || res?.game_name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (res?.legacy == "aura") {
                                handelChange(res, "poker", "first");
                              } else {
                                handel(res);
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Evolution" title="Evolution">
              <Row>
                {EvolutionNew?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (isEmpty(user)) {
                                setLoginModal(true);
                              } else {
                                launchCasino({
                                  platForm: res?.platFormCode,
                                  gameType: res?.gameType,
                                  casinoType: res?.casinoType,
                                  isLobbyTrue: res?.isLobbyTrue,
                                });
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
            {/* <Tab eventKey="Ezugi" title="Ezugi">
              <Row>
                {EzugiNew?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => {
                              if (isEmpty(user)) {
                                setLoginModal(true);
                              } else {
                                // dolaunchCasinoRyoal({
                                //   game_code: res?.gameCode,
                                //   game_id: res?.gameId,
                                //   game_name: res?.name,
                                //   provider_name: "EZUGI",
                                //   category: res?.Cat,
                                //   deviceType: "web",
                                //   isLobby:
                                //     res?.category == "LOBBY" ? true : false,
                                // });
                              }
                            }}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab> */}
            <Tab eventKey="royal" title={"Royal Gamming"}>
              <Row>
                {RoyalGammingNew?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <ImageWithFallback
                          src={res?.img || res?.img}
                          fallbackSrc={
                            "https://cdn.dreamdelhi.com/gap-logo.webp"
                          }
                        />

                        <h2 style={{ marginTop: "6px" }}>
                          <a href="/CasinoDetail">{res?.game_name}</a>
                        </h2>
                        <div className="game-item-overlay">
                          <Button
                           onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Aviator" title="Aviator">
              <Row>
                {AviatorGames?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.image} />
                        <h2>
                          <a href="/CasinoDetail">{res?.title}</a>
                        </h2>
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Live" title="Live">
              <Row>
                {array?.live?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
            <Tab eventKey="Sexy" title="Sexy">
              <Row>
                {array?.sexy?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Table" title="Table">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.table?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.table
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Slot" title="Slot">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.slot?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.slot
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
            <Tab eventKey="Dice" title="Dice">
              <Row>
                {array?.dice?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Fishing" title="Fishing">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.fishing?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.fishing
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="Egame" title="Egame">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.egame?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.egame
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>
            <Tab eventKey="AWC" title="AWC">
              {" "}
              <SubCasino
                setSubCasino={setSubCasino}
                subCasino={subCasino}
                header={key}
              />
              <Row>
                {(!isEmpty(subCasino)
                  ? array?.awc?.filter((res) => {
                      return res?.cateogry == subCasino;
                    })
                  : array?.awc
                )?.map((res) => {
                  return (
                    <Col style={{ marginTop: "10px" }} xs={2}>
                      <div className="cBlock">
                        <img src={res?.img} />
                        <h2>
                          <a href="/CasinoDetail">{res?.name}</a>
                        </h2>{" "}
                        <div className="game-item-overlay">
                          <Button
                            onClick={() => handel(res)}
                            style={{
                              background: "#ffb80c",
                              border: "none",
                              fontWeight: "600",
                              color: "black",
                              fontSize: "13px",
                            }}
                          >
                            Play Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Tab>{" "}
          </Tabs>
        </div>
      </Col>
    </Layout>
  );
}

export default CasinoPage;

const live = ["SEXY", "EVO", "PT", "PP", "HOTROAD"];
const table = ["KINGMAKER", "NETENT", "JILI"];
const slot = [
  "PP",
  "KINGMAKER",
  "DRAGOONSOFT",
  "NETENT",
  "SPADE",
  "PT",
  "JDB",
  "FC",
  "JILI",
];
const fishing = ["SPADE", "JDB", "JILI"];
const egame = ["SPRIBE", "PP", "JDB"];
const awc = ["BG", "BTG", "E1SPORT", "NLC", "RT", "SV388", "YesBingo", "YL"];
const obj = {
  Live: live,
  Slot: slot,
  Table: table,
  Fishing: fishing,
  Egame: egame,
  AWC: awc,
};

let dummy = [
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-001",
    Name: "Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-002",
    Name: "Blackjack A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-003",
    Name: "Craps",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-004",
    Name: "Dragon Tiger",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-005",
    Name: "Super Sic Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    Name: "Crazy Time",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    Name: "MONOPOLY Live",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-008",
    Name: "Instant Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-009",
    Name: "Triple Card Poker",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-010",
    Name: "Mega Ball",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-011",
    Name: "Lightning Dice",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-012",
    Name: "Infinite Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-013",
    Name: "First Person Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-014",
    Name: "Crazy Coin Flip",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-015",
    Name: "Casino Hold'em",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-016",
    Name: "Power Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-017",
    Name: "First Person Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-018",
    Name: "MONOPOLY Big Baller",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-020",
    Name: "American Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-021",
    Name: "2 Hand Casino Hold'em",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-023",
    Name: "First Person Dream Catcher",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-024",
    Name: "Caribbean Stud Poker",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-025",
    Name: "Deal or No Deal",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-026",
    Name: "Teen Patti",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-027",
    Name: "Texas Hold'em Bonus Poker",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-029",
    Name: "First Person Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-030",
    Name: "First Person Football Studio",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-031",
    Name: "First Person Craps",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-032",
    Name: "Extreme Texas Hold'em",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-033",
    Name: "First Person Dragon Tiger",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-034",
    Name: "First Person Mega Ball",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-035",
    Name: "Dream Catcher",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-036",
    Name: "Baccarat Squeeze",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-037",
    Name: "Infinite Free Bet Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-038",
    Name: "No Commission Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-039",
    Name: "Blackjack VIP B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-040",
    Name: "Lightning Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-041",
    Name: "Baccarat Control Squeeze",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-042",
    Name: "Blackjack Party",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-043",
    Name: "Double Ball Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-044",
    Name: "Football Studio Dice",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-045",
    Name: "Football Studio",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-046",
    Name: "First Person Golden Wealth Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-047",
    Name: "Emperor Sic Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-049",
    Name: "Blackjack VIP U",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-050",
    Name: "Blackjack VIP 1",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-051",
    Name: "Blackjack Silver E",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-052",
    Name: "Blackjack VIP 25",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-053",
    Name: "Blackjack Silver B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-054",
    Name: "Blackjack VIP 12",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-055",
    Name: "Blackjack VIP 15",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-056",
    Name: "Blackjack Silver C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-057",
    Name: "Blackjack VIP X",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-058",
    Name: "Blackjack VIP Alpha",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-059",
    Name: "Blackjack VIP D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-060",
    Name: "Blackjack VIP Gamma",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-061",
    Name: "Blackjack VIP G",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-062",
    Name: "Blackjack VIP V",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-063",
    Name: "Blackjack VIP 20",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-064",
    Name: "Blackjack VIP 7",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-065",
    Name: "Blackjack VIP I",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-066",
    Name: "Blackjack VIP 16",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-067",
    Name: "Blackjack VIP Beta",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-068",
    Name: "Blackjack Silver G",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-069",
    Name: "Blackjack VIP E",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-070",
    Name: "Blackjack Silver F",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-071",
    Name: "Blackjack VIP M",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-072",
    Name: "Blackjack VIP 14",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-073",
    Name: "Blackjack VIP 10",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-074",
    Name: "Blackjack Silver D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-075",
    Name: "Blackjack Silver A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-076",
    Name: "Blackjack VIP Z",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-077",
    Name: "Emperor Dragon Tiger",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-078",
    Name: "Speed Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-079",
    Name: "VIP Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-080",
    Name: "Emperor Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-081",
    Name: "Salon Privé Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-082",
    Name: "Blackjack B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-083",
    Name: "Blackjack C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-084",
    Name: "Blackjack VIP 11",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-085",
    Name: "Blackjack VIP 13",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-086",
    Name: "Blackjack VIP 17",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-087",
    Name: "Blackjack VIP 18",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-088",
    Name: "Blackjack VIP 19",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-089",
    Name: "Blackjack VIP 2",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-090",
    Name: "Blackjack VIP 21",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-091",
    Name: "Blackjack VIP 22",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-092",
    Name: "Blackjack VIP 26",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-093",
    Name: "Blackjack VIP 27",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-094",
    Name: "Blackjack VIP 3",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-095",
    Name: "Blackjack VIP 4",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-096",
    Name: "Blackjack VIP 5",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-097",
    Name: "Blackjack VIP 6",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-098",
    Name: "Blackjack VIP 8",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-099",
    Name: "Blackjack VIP 9",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-100",
    Name: "Blackjack VIP A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-101",
    Name: "Blackjack VIP C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-102",
    Name: "Blackjack VIP F",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-103",
    Name: "Blackjack VIP H",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-104",
    Name: "Blackjack VIP J",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-105",
    Name: "Blackjack VIP K",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-106",
    Name: "Blackjack VIP L",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-107",
    Name: "Blackjack VIP N",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-108",
    Name: "Blackjack VIP O",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-109",
    Name: "Blackjack VIP P",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-110",
    Name: "Blackjack VIP Q",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-111",
    Name: "Blackjack VIP R",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-112",
    Name: "Blackjack VIP S",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-113",
    Name: "Blackjack VIP T",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-114",
    Name: "Crazy Time A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-115",
    Name: "Blackjack Fortune VIP",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-116",
    Name: "Blackjack Grand VIP",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-117",
    Name: "Blackjack Platinum VIP",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-118",
    Name: "Blackjack Diamond VIP",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-120",
    Name: "Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-121",
    Name: "Salon Privé Baccarat G",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-122",
    Name: "Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-123",
    Name: "Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-124",
    Name: "Salon Privé Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-125",
    Name: "Salon Privé Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-126",
    Name: "Salon Privé Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-127",
    Name: "Salon Privé Baccarat D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-128",
    Name: "Salon Privé Baccarat E",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-129",
    Name: "Salon Privé Baccarat F",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-130",
    Name: "Salon Privé Baccarat H",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-131",
    Name: "Salon Privé Baccarat I",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-132",
    Name: "Salon Privé Baccarat J",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    Name: "Lightning Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-134",
    Name: "No Commission Speed Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-135",
    Name: "No Commission Speed Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-136",
    Name: "No Commission Speed Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-137",
    Name: "Speed Baccarat F",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-138",
    Name: "Speed Baccarat I",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-139",
    Name: "Speed Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-140",
    Name: "Speed Baccarat H",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-141",
    Name: "Speed Baccarat Q",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-142",
    Name: "Speed Baccarat M",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-143",
    Name: "Speed Baccarat X",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-144",
    Name: "Speed Baccarat O",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-145",
    Name: "Speed Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-146",
    Name: "Speed Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-147",
    Name: "Emperor Speed Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-148",
    Name: "Speed Baccarat E",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-149",
    Name: "Speed Baccarat P",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-150",
    Name: "Emperor Speed Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-151",
    Name: "Speed Baccarat K",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-152",
    Name: "Speed Baccarat W",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-153",
    Name: "Emperor Speed Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-154",
    Name: "Speed Baccarat G",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-155",
    Name: "Speed Baccarat L",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-156",
    Name: "Speed Baccarat N",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-157",
    Name: "Speed Baccarat J",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-158",
    Name: "Speed Baccarat D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-159",
    Name: "Speed Baccarat 1",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-160",
    Name: "Speed Baccarat 2",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-161",
    Name: "Speed Baccarat 3",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-162",
    Name: "Speed Baccarat R",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-163",
    Name: "Speed Baccarat S",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-164",
    Name: "Speed Baccarat T",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-165",
    Name: "Speed Baccarat U",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-166",
    Name: "Speed Baccarat V",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-167",
    Name: "Speed Baccarat Z",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-168",
    Name: "Extra Chili Epic Spins",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-169",
    Name: "Imperial Quest",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-170",
    Name: "Auto-Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-171",
    Name: "Auto-Roulette VIP",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-172",
    Name: "Bac Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-173",
    Name: "Speed Blackjack H",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-175",
    Name: "Cash Or Crash",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-176",
    Name: "Dead or Alive: Saloon",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-177",
    Name: "Speed Blackjack D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
    Name: "Fan Tan",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-179",
    Name: "Golden Wealth Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-180",
    Name: "Immersive Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-181",
    Name: "Lightning Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-182",
    Name: "Peek Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    Name: "Funky Time",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-184",
    Name: "Speed Blackjack E",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-185",
    Name: "Speed Blackjack G",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-186",
    Name: "Speed Blackjack I",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-187",
    Name: "Speed Blackjack J",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-188",
    Name: "Speed Blackjack K",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-189",
    Name: "Speed Blackjack L",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-190",
    Name: "Speed Blackjack M",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-191",
    Name: "Speed VIP Blackjack A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-192",
    Name: "Speed VIP Blackjack B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-193",
    Name: "Speed VIP Blackjack C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-194",
    Name: "Speed VIP Blackjack D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-195",
    Name: "Speed VIP Blackjack E",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-196",
    Name: "Speed VIP Blackjack F",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-197",
    Name: "Speed VIP Blackjack G",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-198",
    Name: "Speed VIP Blackjack H",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-199",
    Name: "Speed VIP Blackjack I",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-200",
    Name: "Speed VIP Blackjack J",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-201",
    Name: "Speed VIP Blackjack K",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-202",
    Name: "Speed VIP Blackjack L",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-203",
    Name: "Speed VIP Blackjack M",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    Name: "Super Andar Bahar",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-205",
    Name: "XXXtreme Lightning Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-206",
    Name: "First Person American Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-207",
    Name: "First Person Lightning Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-208",
    Name: "First Person Lightning Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-209",
    Name: "First Person Lightning Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-210",
    Name: "Emperor Speed Baccarat D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-211",
    Name: "Emperor Sic Bo A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-212",
    Name: "Speed Auto Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-214",
    Name: "Football Studio Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-215",
    Name: "Salon Privé Blackjack A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-216",
    Name: "Salon Privé Blackjack B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-217",
    Name: "Salon Privé Blackjack C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-218",
    Name: "Salon Privé Blackjack D",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-219",
    Name: "Salon Privé Blackjack E",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-220",
    Name: "Salon Privé Blackjack F",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-221",
    Name: "Salon Privé Blackjack G",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-222",
    Name: "Salon Privé Blackjack H",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-223",
    Name: "Salon Privé Blackjack I",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-224",
    Name: "Salon Privé Blackjack J",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-225",
    Name: "First Person Deal or No Deal",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-226",
    Name: "First Person XXXtreme Lightning Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-227",
    Name: "Video Poker",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-228",
    Name: "Gold Vault Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-229",
    Name: "Hindi Speed Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-230",
    Name: "Emperor Bac Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-231",
    Name: "Bonsai Speed Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-232",
    Name: "Bonsai Speed Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-233",
    Name: "Bonsai Speed Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-234",
    Name: "Blackjack VIP 28",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-235",
    Name: "Blackjack VIP 29",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-236",
    Name: "Salon Privé Baccarat K",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-237",
    Name: "Salon Privé Baccarat L",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-238",
    Name: "Speed VIP Blackjack N",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-239",
    Name: "Speed VIP Blackjack O",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-240",
    Name: "Speed VIP Blackjack P",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-241",
    Name: "Speed VIP Blackjack Q",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-242",
    Name: "Speed VIP Blackjack R",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-243",
    Name: "Blackjack VIP 30",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-244",
    Name: "First Person Prosperity Tree Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-245",
    Name: "Prosperity Tree Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-246",
    Name: "Gonzo's Treasure Map",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-247",
    Name: "Speed Baccarat 4",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-248",
    Name: "Speed Baccarat 5",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-249",
    Name: "Speed Baccarat 6",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-250",
    Name: "Speed Baccarat 9",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-253",
    Name: "Speed Baccarat 10",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-254",
    Name: "Speed Baccarat 11",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    Name: "XXXtreme lightning Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-256",
    Name: "First person XXXtreme lightning Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-257",
    Name: "Red Door Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-258",
    Name: "First person Video Poker",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-259",
    Name: "First Person Super Sic Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-260",
    Name: "Speed Super Sic Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-261",
    Name: "Crazy Pachinko",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-262",
    Name: "Speed Baccarat 12",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-263",
    Name: "Evo Speed Blackjack 1",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-264",
    Name: "Evo Speed Blackjack 2",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-265",
    Name: "Evo Speed Blackjack 3",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-266",
    Name: "Evo Speed Blackjack 4",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-267",
    Name: "Evo Speed Blackjack 5",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-268",
    Name: "Evo Speed Blackjack 6",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-269",
    Name: "Evo Speed Blackjack 7",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-270",
    Name: "Evo Speed Blackjack 8",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-271",
    Name: "Salon Privé Baccarat M",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-272",
    Name: "Salon Privé Baccarat N",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-273",
    Name: "Speed Baccarat 7",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-274",
    Name: "Speed Baccarat 8",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-275",
    Name: "Blackjack VIP 31",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-276",
    Name: "Blackjack VIP 32",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-277",
    Name: "Hindi Speed Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-278",
    Name: "Evo Speed Blackjack 9",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-279",
    Name: "Evo Speed Blackjack 10",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-280",
    Name: "Evo Speed Blackjack 11",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-281",
    Name: "Blackjack VIP 33",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-282",
    Name: "Blackjack VIP 34",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-283",
    Name: "Blackjack VIP 35",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-286",
    Name: "Blackjack VIP 38",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-287",
    Name: "Blackjack VIP 41",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-288",
    Name: "Blackjack VIP 42",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-289",
    Name: "Blackjack VIP 43",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-290",
    Name: "Blackjack VIP 44",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-291",
    Name: "Stock Market",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-292",
    Name: "First Person Stock Market",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-314",
    Name: "Free Bet VIP Blackjack A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-332",
    Name: "Blackjack VIP 36",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-333",
    Name: "Blackjack VIP 37",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-339",
    Name: "Blackjack VIP 50",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-344",
    Name: "Lightning Dragon Tiger",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-362",
    Name: "Lightning Sic Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-363",
    Name: "Balloon Race",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-364",
    Name: "First Person HiLo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-365",
    Name: "Salon Privé Blackjack K",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-366",
    Name: "Salon Privé Blackjack L",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-367",
    Name: "Salon Privé Blackjack M",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-368",
    Name: "Salon Privé Blackjack N",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-369",
    Name: "Lightning Storm",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-376",
    Name: "Lightning Ball",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-377",
    Name: "Platinum Privé Blackjack 1",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-378",
    Name: "Platinum Privé Blackjack 2",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-379",
    Name: "Platinum Privé Blackjack 3",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-380",
    Name: "Platinum Privé Blackjack 4",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-381",
    Name: "Platinum Privé Blackjack 5",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-382",
    Name: "Platinum Privé Blackjack 6",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-383",
    Name: "Platinum Privé Blackjack 7",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-386",
    Name: "Salon Privé Blackjack O",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-387",
    Name: "Salon Privé Blackjack P",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-388",
    Name: "Salon Privé Blackjack Q",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-397",
    Name: "Infinite Fun Fun 21 Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-398",
    Name: "Super Speed Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-408",
    Name: "Bet with Streamers",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-409",
    Name: "Crazy Balls",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-410",
    Name: "Always 8 Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-411",
    Name: "Lotus Sic Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-412",
    Name: "Infinite Bet Stacker Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-413",
    Name: "Easy Blackjack",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-414",
    Name: "Emperor Golden Wealth Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-415",
    Name: "Thai Speed Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-416",
    Name: "Lotus Speed Baccarat A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-417",
    Name: "Lotus Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-420",
    Name: "Lotus Speed Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-421",
    Name: "Lotus Speed Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-422",
    Name: "VIP Bet Stacker Blackjack 1",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-423",
    Name: "VIP Bet Stacker Blackjack 2",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-424",
    Name: "VIP Bet Stacker Blackjack 3",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-425",
    Name: "VIP Bet Stacker Blackjack 4",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-426",
    Name: "Race Track",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-427",
    Name: "Race Track A",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-428",
    Name: "Bet with Streamers",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-429",
    Name: "Hindi Lightning Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-430",
    Name: "Hindi Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-431",
    Name: "War",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-432",
    Name: "Thai Speed Baccarat B",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-433",
    Name: "Thai Speed Baccarat C",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-434",
    Name: "Marble Race",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-435",
    Name: "Super Color Game",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-436",
    Name: "Fireball Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-440",
    Name: "Lightning Bac Bo",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-441",
    Name: "Dynasty Speed  Baccarat 1",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-442",
    Name: "Dynasty Speed  Baccarat 2",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-443",
    Name: "Dynasty Speed  Baccarat 3",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-444",
    Name: "Dynasty Speed  Baccarat 4",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-445",
    Name: "Dynasty Speed  Baccarat 5",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-446",
    Name: "Dynasty Speed  Baccarat 6",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-447",
    Name: "Dynasty Speed  Baccarat 7",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-448",
    Name: "Dynasty Speed  Baccarat 8",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-449",
    Name: "Ice Fishing",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-450",
    Name: "Dynasty Lightning Roulette",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-451",
    Name: "Super Speed Dragon Tiger ",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-453",
    Name: "Dragon Tiger Phoenix",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-454",
    Name: "Always 9 Baccarat",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-455",
    Name: "Red Baron",
  },
  {
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-456",
    Name: "Red Baron A",
  },
];
